export default __webpack_public_path__ + "static/media/workwell.25a37689.png";